<template>
    <common-content-spacer height="small" :isCenter="true">
        <div class="profile-photo-upload__image">
            <img v-if="previewPhoto" :src="previewPhoto" height="100" width="100" />
            <common-icon v-else class="profile-photo-upload__icon" name="user-profile-gray" size="ultra-large"></common-icon>
        </div>
        <common-button
            :isSubmittable="false"
            :label="$t(uploadButtonLabel)"
            type="link"
            @click="openPhotoUploadModal"
        ></common-button>

        <profile-photo-upload-modal
            ref="profilePhotoUploadModal"
            :isOpen="isPhotoUploadModalOpen"
            :previewPhoto="previewPhoto"
            @close="closePhotoUploadModal"
            @save-photo="savePhoto"
            @remove-photo="removePhoto"
        ></profile-photo-upload-modal>
    </common-content-spacer>
</template>

<script>
    import ProfilePhotoUploadModal from 'components/page-elements/profile/ProfilePhotoUploadModal'

    export default {
        components: { ProfilePhotoUploadModal },

        props: {
            uploadButtonLabel: {
                type: String,
                default: 'forms.profile.account_information.buttons.upload_profile_picture',
            },
            previewPhoto: { type: String, default: '' },
        },

        data() {
            return {
                isPhotoUploadModalOpen: false,
            }
        },

        computed: {
            isUserAvatarAvailable() {
                const user = this.$auth.getActiveMember()
                return user.avatar && user.avatar.source
            },
        },

        methods: {
            openPhotoUploadModal() {
                this.isPhotoUploadModalOpen = true
            },
            closePhotoUploadModal() {
                this.isPhotoUploadModalOpen = false
            },

            savePhoto(file) {
                this.$emit('save-photo', file)
            },

            removePhoto() {
                this.$emit('remove-photo')
            },

            resetPhotoUploadModal() {
                this.$refs.profilePhotoUploadModal.resetModal()
            },
        },
    }
</script>
